import React from 'react'

function getSize(el) {
  const bbox = el.getBoundingClientRect()
  return {
    width: bbox.width,
    height: bbox.height,
    isMobile: bbox.width < 600
  }
}

function useSize() {
  const container = React.useRef(null)
  const [size, setSize] = React.useState({
    width: 581,
    height: 0,
    isMobile: true
  })
  const handleResize = React.useCallback(
    function handleResize() {
      if (container.current !== null) {
        setSize(getSize(container.current))
      }
    },
    [container]
  )
  React.useLayoutEffect(() => {
    handleResize()
    window.addEventListener('resize', handleResize)
    return function() {
      window.removeEventListener('resize', handleResize)
    }
  }, [container])

  return [container, size]
}

export default useSize
